<div
  class="container-lg g-0 search-secondary-navigation-main-container"
  *ngIf="
    (searchResult?.searchResultList && searchResult?.searchResultList?.length) ||
    searchResult?.narrowByFacets?.clearAllFacetValue
  "
>
  <div class="row">
    <ng-container *ngFor="let node of searchResult?.categoryFacet?.selectedFacetsWithChildren; let i = index">
      <div class="col-12 col-md-4" *ngIf="node.children && node.children?.length">
        <app-secondary-navigation-dropdown [searchFacetValueNode]="node" [searchResult]="searchResult"></app-secondary-navigation-dropdown>
      </div>
    </ng-container>
    <div class="col-12 col-md-4" *ngIf="searchResult?.narrowByFacets?.displayFilterByDropdown">
      <app-secondary-navigation-dropdown-filter [narrowByFacets]="searchResult?.narrowByFacets?.narrowByFacets" [searchResult]="searchResult">
      </app-secondary-navigation-dropdown-filter>
    </div>
  </div>
</div>
